import * as v from "valibot";
function createEnv(args) {
  const isPrivate = args.isPrivate ?? typeof window === "undefined";
  let schemaRecord = {
    ...args.schema.public,
    ...args.schema.shared
  };
  if (isPrivate) {
    schemaRecord = {
      ...schemaRecord,
      ...args.schema.private
    };
  }
  try {
    return v.parse(v.object(schemaRecord), args.values);
  } catch (error) {
    if (v.isValiError(error)) {
      const invalidPaths = error.issues.map((issue) => "	" + [v.getDotPath(issue), issue.message].join(": ")).join("\n");
      throw new Error(
        `[valibot-env] Invalid environment variable values detected. Please check the following variables:
${invalidPaths}`,
        { cause: error }
      );
    }
    throw error;
  }
}
export {
  createEnv
};
//# sourceMappingURL=index.js.map